var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner",class:_vm.classes,attrs:{"id":"spinner"}})
}
var staticRenderFns = []

export { render, staticRenderFns }